// axios
import axios from "axios";
import brand from "./brand";

const domain = brand.apiBase;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: domain, // replace with your API base URL
  timeout: 15000,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify config, add headers, etc.
    config.headers["Cid"] = config.params.Cid;
    // For example, add an authorization token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.headers["X-Loading"] !== false) {
      document.dispatchEvent(
        new CustomEvent("loader", { detail: { loading: true } })
      );
    }
    return config;
  },
  (error) => {
    // Handle request error
    document.dispatchEvent(
      new CustomEvent("loader", { detail: { loading: false } })
    );
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Handle response data
    document.dispatchEvent(
      new CustomEvent("loader", { detail: { loading: false } })
    );
    if (response.status == 204) {
      return Promise.reject();
    }
    response.data = brand.normalize(response.data);
    return response;
  },
  (error) => {
    // Handle response error
    document.dispatchEvent(
      new CustomEvent("loader", { detail: { loading: false } })
    );
    if (error.response && error.response.status === 401) {
      // For example, redirect to login if unauthorized
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
